import { render, staticRenderFns } from "./SocketDebugBar.vue?vue&type=template&id=b2c1e6b4&scoped=true&"
import script from "./SocketDebugBar.vue?vue&type=script&lang=js&"
export * from "./SocketDebugBar.vue?vue&type=script&lang=js&"
import style0 from "./SocketDebugBar.vue?vue&type=style&index=0&id=b2c1e6b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c1e6b4",
  null
  
)

export default component.exports